import AdvancedCalculator from './AdvancedCalculator';

export default AdvancedCalculator;
